module.exports = __webpack_public_path__ + "img/project-gantt.fc6fb198.png";